<style src="./parking-list.scss" lang="scss"></style>
<template>
  <section class="parking-list">
    <div class="commands">
      <button
        class="btntab"
        type="button"
        @click="() => showPanel('area')">
        Áreas
      </button>
      <button
        class="btntab"
        type="button"
        @click="() => showPanel('spots')">
        Vagas
      </button>
      <button
        class="btntab"
        type="button"
        @click="() => showPanel('monitor')">
        Monitor
      </button>
      <button
        class="btntab"
        type="button"
        @click="refreshSentinel">
        <i class="fa fa-refresh"></i>
      </button>
    </div>

    <div class="parkcontainer" v-show="panelName === 'area'">
      <div class="parks">
        <label
          class="park"
          v-for="(park, parkIdx) in parks"
          :key="parkIdx">
          <input
            type="checkbox"
            :value="park"
            v-model="selectedParks">
            <span class="parkname">{{ park.parkName }}</span>
        </label>
      </div>
    </div>

    <div class="parkcontainer" v-show="panelName === 'spots'">
      <div class="spots">
        <div
          class="parks"
          v-for="(spot, spotIdx) in selectedParks"
          :key="spotIdx">
          <span class="parkname">{{ spot.parkName }}</span>

          <label
            class="spot"
            v-for="(spots, spotsIdx) in spot.spots"
            :key="spotsIdx"
            :class="{ 'withphoto': spotWithPhoto.includes(spots.spotId) }">
            <input
              type="checkbox"
              :value="spots.spotId"
              v-model="selectedSpots">
            <div class="indicator">
              <i
                class="icon fa fa-camera"
                v-if="spotWithPhoto.includes(spots.spotId)">
              </i>
              <span class="spotname">{{ spots.spotName }}</span>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="parkcontainer" v-show="panelName === 'monitor'">
      <div class="spots">
        <div
          class="parks"
          v-for="(monitorSpot, monitorSpotIdx) in monitorSpotsList"
          :key="monitorSpotIdx">
          <span class="parkname">{{ monitorSpot.parkName }}</span>

          <label
            class="spot"
            v-for="(spots, spotsIdx) in monitorSpot.spots"
            :key="spotsIdx">
            <input
              type="radio"
              :value="spots.spotId"
              v-model="selectedSentinel">
            <div class="indicator">
              <i
                class="icon fa fa-camera">
              </i>
              <span class="spotname">{{ spots.spotName }}</span>
            </div>
          </label>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    parks: [],
    sentinel: null,
  },
  data: () => ({
    panelName: 'area',
    selectedSpots: [],
    selectedParks: [],
    spotWithPhoto: [],
    selectedSentinel: [],
  }),
  computed: {
    spots() {
      const parks = this.selectedParks;
      return parks;
    },
    monitorSpotsList() {
      const monitorSpots = [];
      for (const monitorSpot in this.selectedParks) {
        const spots = this.selectedParks[monitorSpot].spots
          .filter(item => this.selectedSpots.includes(item.spotId));
        if (spots.length) {
          const monitor = {
            ...this.selectedParks[monitorSpot],
            spots,
          }
          monitorSpots.push(monitor)
        }
      }
      return monitorSpots;
    },
  },
  watch: {
    selectedSpots(v) {
      const filtered = [];
      for (const spot in this.sentinel) {
        if (v.includes(this.sentinel[spot].spotId)) {
          filtered.push(this.sentinel[spot]);
        }
      }
      this.$emit('selected-spots', filtered);
    },
    sentinel(v) { this.computeSentinel(v); },
    selectedSentinel(v) {
      const sentinelSpot = this.findSentielSpot(v);
      this.$emit('selected-sentinel', sentinelSpot);
    }
  },
  methods: {
    showPanel(panelName) {
      this.panelName = panelName;
    },
    computeSentinel(info) {
      if (!(info && Object.keys(info).length)) return;
      const spotsWithPhoto = Object.keys(info).map(spot => info[spot].spotId);
      this.spotWithPhoto = spotsWithPhoto;
    },
    findSentielSpot(spotId) {
      const sentinelSpots = [];
      for (const parks in this.sentinel) {
        if (this.sentinel[parks].spotId === spotId) {
          sentinelSpots.push(this.sentinel[parks]);
        }
      }
      return sentinelSpots;
    },
    refreshSentinel() {
      this.$emit('refresh-sentinel');
    }
  }
}
</script>
